<template>
  <footer class="footer">
    <b-container>
      <b-row>
        <b-col md="12">
          <b-row>
            <b-col xl="8">
              <div class="address">
                <p>
                  <span>Energieagentur St.Gallen GmbH</span>
                  <span class="divider"> | </span>
                  <span>Kornhausstrasse 25 | 9000 St.Gallen</span><br>
                  <span>Tel. <a href="tel:0582287171">058 228 71 71</a></span>
                  <span class="divider"> | </span>
                  <span><a href="mailto:info@energieagentur-sg.ch">info@energieagentur-sg.ch</a></span>
                </p>
              </div>
            </b-col>
            <b-col xl="4">
              <div class="social">
                <span>Folgen auf</span>
                <span><a href="https://www.facebook.com/energieagentur.sg" title="Folgen auf Facebook" class="icon facebook" target="_blank">Facebook</a></span>
                <span><a href="https://twitter.com/EnA_StGallen" title="Folgen auf Twitter" class="icon twitter" target="_blank">Twitter</a></span>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="8" class="order-2 order-xl-1 text-center text-xl-left">
          <p>
            <span>Version {{ version }}</span> |
            <a v-on:click="openModal('agb')" v-b-modal.modal-scrollable-nb>Nutzungsbedingungen</a> |
            <a v-on:click="openModal('datenschutz')" v-b-modal.modal-scrollable-nb>Datenschutz</a> |
            <a v-on:click="openModal('impressum')" v-b-modal.modal-scrollable-nb>Impressum</a> |
            <a href="javascript:void(0);" onclick="window.biskoui.showBanner()">Datenschutzeinstellungen</a>
            <modalagb :showContent="showContent" :modalTitle="modalTitle"/>
          </p>
        </b-col>
      </b-row>
    </b-container>
  </footer>
</template>

<script>
  import modalagb from '@/components/login/Modal'

  export default {
    data: () => ({
      showContent: '',
      modalTitle: '',
      version: process.env.VUE_APP_VERSION
    }),
    components: {
      modalagb
    },
    methods: {
      openModal (modal) {
        if (modal === 'agb') {
          this.showContent = 'agb'
          this.modalTitle = 'Nutzungsbedingungen'
        } else if (modal === 'datenschutz') {
          this.showContent = 'datenschutz'
          this.modalTitle = 'Datenschutz-Bestimmungen'
        } else if (modal === 'impressum') {
          this.showContent = 'impressum'
          this.modalTitle = 'Impressum'
        } else {
          this.showContent = ''
          this.modalTitle = ''
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .footer{
    color: #fff;
    padding-top: 40px;
    padding-bottom: 40px;
    background: $black-80;
    margin-top: 1rem;

    .address{
      text-align: left;

      @include media-breakpoint-down(lg) {
        text-align: center;
        margin-bottom: 20px;
      }
    }

    a{
      color: $white;
      text-decoration: none;
      background-color: transparent;

      &:hover{
        text-decoration: underline;
      }

      &.icon{
        display: inline-block;
        margin-left: 15px;
        width: 30px;
        height: 30px;
        text-align: left;
        text-indent: -9999px;
      }

      &.facebook{
        display: inline-block;
        margin-left: 15px;
        width: 30px;
        height: 30px;
        text-align: left;
        text-indent: -9999px;
        background: assets('icon-facebook.svg') no-repeat center center;
        background-size: 30px 30px;
      }

      &.twitter{
        background: assets('icon-twitter.svg') no-repeat center center;
        background-size: 30px 30px;
      }
    }

    .container{
      max-width: 1140px;
    }

    .social{
      text-align: right;
      display: flex;
      align-items: center;
      justify-content: center;

      @include media-breakpoint-down(lg) {
        text-align: center;
        margin-bottom: 20px;
      }
    }

    .Cookie{
      background-color: $gray;
    }

    .Cookie__content{
      a{
        color: $green;

        &:hover{
          color: $green;
        }
      }
    }
  }
</style>
